import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Add as AddIcon, AccountBalance as AccountBalanceIcon } from "@mui/icons-material";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import RegularButton from "components/CustomButtons/Button";
import { getValidAccounts } from "./accountingAccountRelationHelpers";
import AccountingAccountRelationForm from "./AccountingAccountRelationForm";
import columns from "./columns";
import { useSearch } from "hooks/useSearch";
import { useToggle } from "hooks/useToggle";
import { useValidateReload } from "hooks/useValidateReload";
import {
  getAccountingAccountList,
  getAccountingAccountRelationList,
  setAccountingAccountRelationSearchFilters
} from "redux/actions/accountingAccountRelation/accountingAccountRelationActions";
import { ACCOUNTING_ACCOUNT_RELATION_LOADINGS } from "redux/reducers/accountingAccountRelation/accountingAccountRelationTypes";

const TABLE_KEY = "accountingAccountRelation";
const { GET_RELATION_LIST, GET_ACCOUNT_LIST } = ACCOUNTING_ACCOUNT_RELATION_LOADINGS;
const LOADINGS = Object.values(ACCOUNTING_ACCOUNT_RELATION_LOADINGS);

const AccountingAccountRelationView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const {
    accountingAccountList,
    accountingAccountRelationList,
    station,
    hasSearched,
  } = useSelector(({ accountingAccountRelation }) => accountingAccountRelation);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const [open, setOpen] = useToggle();

  const loading = isLoadingComp?.[GET_RELATION_LIST] || isLoadingComp?.[GET_ACCOUNT_LIST] || false;

  useValidateReload(LOADINGS);

  const handleSearch = () => {
    if (!station) {
      setSnackbar("Seleccione una planta.", "warning");
      return;
    }
    dispatch(getAccountingAccountRelationList(station.id));
    dispatch(getAccountingAccountList(station.id));
  };

  const handleForm = () => {
    if (!station) {
      setSnackbar("Seleccione una planta y busque la relación de cuentas antes de asignar una nueva.", "warning");
      return;
    }
    if (!hasSearched) {
      setSnackbar("Busque la relación de cuentas de la planta antes de asignar una nueva.", "warning");
      return;
    }

    const validAccounts = getValidAccounts(accountingAccountList);
    if (!validAccounts.length) {
      setSnackbar("La planta no tiene cuentas para asignar.", "warning");
      return;
    }
    setOpen();
  };

  return (
    <>
      <CardTable
        data={accountingAccountRelationList}
        columns={columns}
        hasHeader
        blockBtn
        title="Relación Cuenta Contable"
        icon={<AccountBalanceIcon />}
        isLoading={loading}
        noDataText={
          !station
            ? "Seleccione una planta y presione buscar"
            : "No hay relaciones de cuentas registradas para esta planta"
        }
        tableContent={
          <TableInputs
            reducer={TABLE_KEY}
            stations
            dispatchAction={setAccountingAccountRelationSearchFilters}
            loading={loading}
            submitAction={handleSearch}
            preventEvent
          />
        }
        tableKey={TABLE_KEY}
        hasControl
        controls={
          <RegularButton round justIcon color="info" onClick={handleForm}>
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      {open && <AccountingAccountRelationForm setOpen={setOpen} open={open} />}
    </>
  );
};

export default AccountingAccountRelationView;
